import Vue from "vue";

if(document.getElementById('app')){
    console.log('found app in dom');

    var app = new Vue({
        el: '#app',
        data: {
            practitioners:  window.app_data.practitioners,
            countries:      window.app_data.countries,
            symptoms:       window.app_data.symptoms,
            practitionerTypes: window.app_data.practitioner_types,

            searchTerm:'',
            searchTermAddress:'',
            filterCountries:[],
            filterSymptoms:[],
            filterPractitionerTypes:[],

            showCountriesPanel:false,
            showSymptomsPanel:false,
            showPractitionerTypesPanel:false,

            currentPage: 1,
            itemsPerPage: 12
        },

        methods:{
            getAreaOfFocusText(practitioner){
                let joined = practitioner.symptoms.join("<br> ");
                if (joined.length > 200){
                    return joined.substring(0,200) + "...";
                }
                return joined;
            },
            clearAll(){
                this.searchTerm='';
                this.filterCountries=[];
                this.filterSymptoms=[];
                this.filterPractitionerTypes=[];
            },
            goToPage(page){
                this.currentPage = page;
            },
            nextPage(){
                if (this.currentPage < this.totalPages) this.currentPage++;
            },
            prevPage(){
                if (this.currentPage > 1) this.currentPage--;
            }
        },

        watch: {
            filteredPractitioners() {
                this.currentPage = 1;
            }
        },

        computed:{
            filteredPractitioners(){
                if(
                    this.searchTerm ==  ''
                    && this.searchTermAddress == ''
                    && this.filterCountries.length==0
                    && this.filterSymptoms.length==0
                    && this.filterPractitionerTypes.length==0
                ){
                    return this.practitioners.sort((a,b)=>(a.sort_name > b.sort_name) ? 1 : ((b.sort_name > a.sort_name) ? -1 : 0));
                }
                return this.practitioners.filter(practitioner =>{
                    //all filters should match. End early if not
                    if(this.searchTerm !==  '' && !practitioner.name_and_zip.toLowerCase().includes(this.searchTerm.toLowerCase())){
                        return false; //no match
                    }
                    if(this.searchTermAddress !==  '' && !practitioner.address.toLowerCase().includes(this.searchTermAddress.toLowerCase())){
                        return false; //no match
                    }
                    if(this.filterCountries.length >=1 && !this.filterCountries.includes(practitioner.country)){
                        return false; //no match
                    }
                    //match any symptom
                    if(this.filterSymptoms.length >=1 && !this.filterSymptoms.some(s=>practitioner.symptoms.includes(s))){
                        return false; //no match
                    }
                    //match any practitioner type
                    if(this.filterPractitionerTypes.length >=1 && !this.filterPractitionerTypes.some(pt=>practitioner.practitioner_types.includes(pt))){
                        return false; //no match
                    }
                    return true;
                }).sort((a,b)=>(a.sort_name > b.sort_name) ? 1 : ((b.sort_name > a.sort_name) ? -1 : 0));
            },
            paginatedPractitioners(){
                const start = (this.currentPage - 1) * this.itemsPerPage;
                const end = start + this.itemsPerPage;
                return this.filteredPractitioners.slice(start, end);
            },
            totalPages(){
                return Math.ceil(this.filteredPractitioners.length / this.itemsPerPage);
            },
            showingStart(){
                return (this.currentPage - 1) * this.itemsPerPage + 1;
            },
            showingEnd(){
                return Math.min(this.currentPage * this.itemsPerPage, this.filteredPractitioners.length);
            }
        }
    });
}

